import { Container } from 'react-bootstrap';
import styled from 'styled-components';

export const StyledLogo = styled.div`
  .logo {
    height: 60px;
  }
`;

export const StyledMenu = styled.div`
  padding: 16px 0;

  .container {
    display: flex;
    justify-content: center;
  }
`;

export const StyledSocialMedia = styled.div`
  display: flex;
  align-items: center;
`;

export const MainNav = () => {
  return (
    <StyledMenu>
      <Container>
        <StyledLogo>
          <a href="https://www.daotienhotel.com/" target="_top">
            <img className="logo" src="/assets/logo192.png" />
          </a>
        </StyledLogo>
      </Container>
    </StyledMenu>
  );
};
